import axiosInstance from "./axiosInstance";
const apiUrl = process.env.REACT_APP_API_URL;

export const createTicketType = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "api/create_ticket_type/",
      payload
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to create ticket type",
      errors: error?.response?.data?.errors || null,
      status: error?.response?.status,
    };
  }
};

export const getTicketTypes = async () => {
  try {
    const response = await axiosInstance.get(
      "api/get_ticket_types/"
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to fetch ticket types",
      status: error?.response?.status,
    };
  }
};

export const updateTicketType = async (tickettypeId, payload) => {
  try {
    const response = await axiosInstance.put(
      `api/update_ticket_type/${tickettypeId}/`,
      payload
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to update ticket type",
      errors: error?.response?.data?.errors || null,
      status: error?.response?.status,
    };
  }
};

export const deleteTicketType = async (tickettypeId) => {
  try {
    const response = await axiosInstance.delete(
      `api/delete_ticket_type/${tickettypeId}/`
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to delete ticket type",
      status: error?.response?.status,
    };
  }
};